import React, { useState } from 'react';
import { audioTracks } from './data/videos';
import './MusicPage.css';

function MusicPage() {
  const [activeIdx, setActiveIdx] = useState(0);

  const handleTrack = (idx) => {
    setActiveIdx(idx);
  };

  const track = audioTracks[activeIdx];

  return (
    <section className="page-section music-page">
      <div className="section-header">
        <p className="section-eyebrow">Listen</p>
        <h2 className="section-title">Music</h2>
        <div className="gold-rule" />
      </div>

      <div className="music-layout">
        <div className="music-player">
          <div className="music-player-video">
            <iframe
              key={track.id}
              src={`https://www.youtube.com/embed/${track.id}?autoplay=1&rel=0&modestbranding=1`}
              title={track.name}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          </div>
          <div className="music-now-playing">
            <div className="music-now-playing-label">Now Playing</div>
            <div className="music-now-playing-title">{track.name}</div>
          </div>
        </div>

        <div className="music-tracklist">
          {audioTracks.map((t, i) => (
            <div
              key={t.id}
              className={`track-item${i === activeIdx ? ' active' : ''}`}
              onClick={() => handleTrack(i)}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => e.key === 'Enter' && handleTrack(i)}
            >
              <span className="track-num">{i + 1}</span>
              <span className="track-name">{t.name}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default MusicPage;
